import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from '../../api';
import { useParams } from "react-router-dom";
import { useSelector,useDispatch} from "react-redux";
import { setSwitchRegion  } from "../../redux/authSlice";

// import { state: { user }  from ''}

const ProductInfo = (props) => {
  const token = useSelector((state) => state.auth.token);
  const [masterDataList, setMasterDataList] = useState([
    { value: "", label: "please select" },
  ]);
  const masterData = masterDataList.length
    ? masterDataList
    : [{ value: "", label: "please select" }];
  const masterOptions = masterData;

  const { userType: role } = useSelector((state) => state.auth.user);

  const id = useParams().id;
  const [product, setProduct] = useState({});
  const dispatch = useDispatch();

   useEffect(() => {
    dispatch(setSwitchRegion(false));
  
    return () => {
        dispatch(setSwitchRegion(true)); // reset when unmounting
    };
    }, [dispatch]);

  useEffect(() => {
    api.products
      .getProductById({ productId: id },token)
      .then((res) => setProduct(res.data));
  }, [id,token]);

  useEffect(() => {
    api.products.getMasterData({},token).then((res) => {
      var masterList = [];
      if (res.code === 200) {
        for (let i of res.data.result) {
          masterList.push({ value: i.masterProdId, label: i.masterProdName });
        }
        setMasterDataList(masterList);
      }
    });
  }, [token]);
// eslint-disable-next-line no-unused-vars
  const getCurrentMasterValue =
    product &&
    product.masterProductIds &&
    product.masterProductIds
      .map((dt) => dt.masterProductId)
      .map((dt) => {
        const currentValue = masterOptions.find((curr) => curr.value === dt);
        return currentValue;
      });

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="box-row">
            <div className="table-head">
              <h1 className="sec-header">VIEW PRODUCT</h1>
            </div>
            <div className="card">
              <div className="card-body box-row">
                {/* <h1 className="section-header">Product Details</h1> */}
                {role !== 3 && (
                  <div
                    style={{ position: "absolute", top: "0px", right: "15px" }}
                  >
                    <Link to={`/edit-products/${product.productId}`}>
                      <button
                        className="btn mt-3 submit-btn"
                        variant="primary"
                        type="submit"
                      >
                        {" "}
                        Edit{" "}
                      </button>
                    </Link>
                  </div>
                )}
                <div style={{ margin: '0px 50px' }}>
                    <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>Product Id</b>{' '}:</span></div>
                        <div className="col-md-8"><span>{product.productId}</span></div>                
                    </div>
                    <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>Product Denomination Name</b>{' '}:</span></div>
                        <div className="col-md-8"><span>{ product.productName}</span></div>                
                    </div>
                    <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>Product Denomination Amount</b>{' '}:</span></div>
                        <div className="col-md-8"><span>{product.productPrice}</span></div>                
                    </div>
                    <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>Product Brand Name</b>{' '}:</span></div>
                        <div className="col-md-8"><span> {Object.keys(product).length
                        ? product.brand.brandName
                        : ""}</span></div>                
                    </div>
                    <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>Product API Access</b>{' '}:</span></div>
                        <div className="col-md-8"><span>{product.productApiAccess
                        ? "true"
                        : "false"}</span></div>                
                    </div>
                    <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>Product Margin</b>{' '}:</span></div>
                        <div className="col-md-8"><span>{product.productMargin}</span></div>                
                    </div>
                    <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>Product Minimum Quantity</b>{' '}:</span></div>
                        <div className="col-md-8"><span>{ product.productThreshold}</span></div>                
                    </div>
                    {Object.keys(product).length && product.refId ? (
                      <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>RefId</b>{' '}:</span></div>
                        <div className="col-md-8"><span>{ product.refId}</span></div>                
                      </div>                  
                    ) : null}                    
                    {Object.keys(product).length && product.refProductId ? (
                      <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>Product RefId </b>{' '}:</span></div>
                        <div className="col-md-8"><span>{ product.refProductId}</span></div>                                   
                      </div>                 
                    ) : null}
                    {Object.keys(product).length && product.sku ? (
                      <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>Product Cut Off Amount </b>{' '}:</span></div>
                        <div className="col-md-8"><span>{ product.genbaCutOffPrice}</span></div>                                   
                      </div>                 
                    ) : null}
                    {Object.keys(product).length && product.sku ? (
                      <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>Steam App Id </b>{' '}:</span></div>
                        <div className="col-md-8"><span>{ product.genbaSteamAppId}</span></div>                                   
                      </div>                 
                    ) : null}
                    {Object.keys(product).length && product.sku ? (
                      <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>Product SKU </b>{' '}:</span></div>
                        <div className="col-md-8"><span>{ product.sku}</span></div>                                   
                      </div>                 
                    ) : null}
                    {Object.keys(product).length && product.masterProductIds ? (
                    <div className="form-group row col-md-12">
                        <div className="col-md-4"><span><b>Master Products </b>{' '}:</span></div>
                        <div className="col-md-8"><span>
                          {product.masterProductIds.map((item) => {
                            return (
                              <div>{item.name}</div>)}
                            )
                          } 
                          </span></div>  
                        {/* <div className="col-md-8"><span> {product.masterProductIds &&
                        product.masterProductIds.map((dt) => {
                          return dt ? (
                            <li key={index}> {dt.label}</li>
                          ) : (
                            <span>{""}</span>
                          );
                        })}</span></div>                 */}
                    </div>  
                    ) : null}                                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductInfo;
